import { Link } from "react-router-dom";
import { Phone, Mail, ArrowUpRight } from "lucide-react";
import BookingLink from "./BookingLink";
import { BUSINESS, NAV } from "../lib/site";

export default function Footer() {
  return (
    <footer className="relative bg-pine text-sage" data-testid="site-footer">
      <div className="container-shell relative z-10 py-10 lg:py-14">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <div className="inline-block rounded-sm bg-white p-3">
              <img src="/img/logo.jpg" alt="Directive Optive Solutions, LLC logo" width="160" height="62" className="h-10 w-auto" />
            </div>
            <p className="max-w-xs font-sans text-xl font-semibold leading-snug text-sage">{BUSINESS.tagline}</p>
          </div>
          <nav aria-label="Footer">
            <p className="eyebrow !text-sage/70">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`} className="transition-colors hover:text-white">{item.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            <p className="eyebrow !text-sage/70">Services</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/services/accounting-bookkeeping" data-testid="footer-link-business-accounting" className="transition-colors hover:text-white">Accounting & Bookkeeping</Link></li>
              <li><Link to="/tax-planning/business" data-testid="footer-link-business-tax" className="transition-colors hover:text-white">Business Tax Planning</Link></li>
              <li><Link to="/tax-planning/personal" data-testid="footer-link-personal-tax" className="transition-colors hover:text-white">Personal Tax Planning</Link></li>
              <li><Link to="/resources" data-testid="footer-link-checklists" className="transition-colors hover:text-white">Preparation Checklists</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow !text-sage/70">Talk to us</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="inline-flex items-center gap-2 transition-colors hover:text-white"><Phone className="h-4 w-4" /> {BUSINESS.phone}</a>
              </li>
              <li>
                <a href={BUSINESS.emailHref} data-testid="footer-email-link" className="inline-flex items-center gap-2 break-all transition-colors hover:text-white"><Mail className="h-4 w-4" /> {BUSINESS.email}</a>
              </li>
              <li>
                <Link to="/book-online" data-testid="footer-booking-link" className="inline-flex items-center gap-1.5 transition-colors hover:text-white">Book online <ArrowUpRight className="h-4 w-4" /></Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-sage/20 pt-6 text-xs text-sage/70">
          <div className="flex flex-col items-center gap-3 text-sm font-semibold text-sage sm:flex-row sm:justify-center sm:gap-10" data-testid="footer-bottom-contact">
            <a href={BUSINESS.phoneHref} data-testid="footer-bottom-phone-link" className="inline-flex items-center gap-2 hover:text-white"><Phone className="h-4 w-4" /> Call {BUSINESS.phone}</a>
            <a href={BUSINESS.emailHref} data-testid="footer-bottom-email-link" className="inline-flex items-center gap-2 hover:text-white"><Mail className="h-4 w-4" /> {BUSINESS.email}</a>
          </div>
          <nav aria-label="Legal" className="mt-5 flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms of Service</Link>
            <Link to="/disclosures" data-testid="footer-disclosures-link" className="hover:text-white">Disclosures</Link>
          </nav>
          <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
            <p>This website is for general information. It is not tax, legal, or financial advice.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
